import React from "react";
import './Body23.css';
import {Link} from "react-router-dom"
import picture342 from './source/picture342.png'
import picture343 from './source/picture343.png'
import picture344 from './source/picture344.png'
import picture345 from './source/picture345.png'





function Body23() {

  return (
    <div className="body23">
      <div className="body23-box1">
        <div className="body23-box2">
          <div className="body23-box3">Ořechov</div>
          <div className="body23-box5"><div className="body23-box4"></div></div>
          <div className="body23-box6">
          <img className="body23-box6-picture" src={picture342} alt="picture1"/>
          <img className="body23-box6-picture" src={picture343} alt="picture1"/>
          <img className="body23-box6-picture" src={picture344} alt="picture1"/>
          <img className="body23-box6-picture" src={picture345} alt="picture1"/>

          </div>
          <div className="body23-box8"><div className="body23-box7"><Link to="/PageProjekty">Zpět</Link></div></div>
        </div> 
      </div> 
    </div>
  );
}

export default Body23;
